<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <div>
          <b-row>
            <b-col>
              <b-card>
                <template slot="header">
                  Glossary
                </template>
                <b-table striped :items="items" :fields="fields">
                </b-table>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'glossary',
  components: {},
  data() {
    return {
      items: [{
          'code': 401,
          'status': 'Unauthorized',
          'description': 'Authenticatie is mislukt, bijvoorbeeld: foutieve inlog-gegevens, invalide Experian credentials.',
        },
        {
          'code': 403,
          'status': 'Forbidden',
          'description': 'Gebruiker is niet gemachtigd om een bepaalde actie uit te voeren. Dit kan optreden omdat de gebruiker geen Experian credentials heeft, of mogelijk door foutieve invoer van gegevens voor de aanvraag.',
        },
        {
          'code': 429,
          'status': 'Too Many Requests',
          'description': 'Er zijn teveel requests/aanvragen gedaan binnen een bepaalde tijd. Om een DDOS te voorkomen, mag een gebruiker maximaal 30 requests per minuut uitvoeren. Mocht deze melding zich voordoen, wacht dan 5 minuten.',
        },
        {
          'code': 500,
          'status': 'Internal Server Error',
          'description': 'Een (onbekende) server fout. Neem contact op met de development partij.',
        },
      ],
      fields: [
        {
          key: 'code',
          label: 'Code',
        },
        {
          key: 'status',
          label: 'Status',
        },
        {
          key: 'description',
          label: 'Omschrijving',
        }
      ],
    }
  },
}

</script>
